// Errors Sentry should drop before they become issues. Only add an entry with
// evidence that none of our code is involved — each one is a blind spot.
export const SENTRY_IGNORE_ERRORS = [
  // CefSharp (.NET-embedded Chromium) link scanners — Outlook Safe Links /
  // Microsoft Defender opening links from our emails. They reject a promise
  // with this plain string, no stack frames. The SDK's default only covers
  // MethodName:simulateEvent; Sentry 7750463156 (2026-09-23) was
  // MethodName:update from a Microsoft IP, Referer r.email.prozpects.com.
  /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+$/,
];
